import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { AlgoliaSearchFilters, capitalizeLabel, sortExperienceLevels } from "components/algolia";

export const industryAttribute = "industry.name";
export const experienceAttribute = "experienceLevel";
export const teamAttribute = "team.name";

type SidebarFiltersProps = {
  query: string;
  sidebarTop: number[] | number;
  headerHeight: string;
};

function PlaybooksSidebarFilters({ query, sidebarTop, headerHeight }: SidebarFiltersProps) {
  return (
    <Box
      as="aside"
      display={["none", "none", "none", "initial"]}
      w="22%"
      position="sticky"
      top={headerHeight}
      pt={sidebarTop}
    >
      <Flex direction="column" maxH={`calc(100vh - ${headerHeight} - 40px)`} overflowY="auto" flex="1" minH={0}>
        <FilterTitle title="Industry" />
        <Box>
          <AlgoliaSearchFilters attribute={industryAttribute} query={query} />
        </Box>

        <FilterTitle title="Experience level" />
        <Box>
          <AlgoliaSearchFilters
            attribute={experienceAttribute}
            query={query}
            sortBy={sortExperienceLevels}
            transformItems={capitalizeLabel}
          />
        </Box>

        <FilterTitle title="Team" />
        <Box>
          <AlgoliaSearchFilters attribute={teamAttribute} query={query} />
        </Box>
      </Flex>
    </Box>
  );
}

function FilterTitle({ title }: { title: string }) {
  return (
    <Box flex="none" px="tiniest">
      <Text fontWeight="semibold" fontSize="brand.md" mb="smaller">
        {title}
      </Text>
    </Box>
  );
}

export default PlaybooksSidebarFilters;
